import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './pages/login/login.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { RegisterComponent } from './pages/register/register.component';
import { LevelDashboardComponent } from './pages/level-dashboard/level-dashboard.component';

import { AuthGuard } from './guards/auth.guard';
import { LevelResolver } from './resolvers/level.resolver';
import { ApplicationTextResolver } from './resolvers/application-text.resolver';
import { AudioGuard } from './guards/audio.guard';
import { CreateAvatarComponent } from './pages/create-avatar/create-avatar.component';
import { GameComponent } from './games/game/game.component';
import { GameResolver } from './resolvers/game.resolver';
import { CheckAvatarGuard } from './guards/check-avatar.guard';
import { GameGuard } from './guards/game.guard';
import { ProgressResolver } from './resolvers/progress.resolver';
import { LevelGuard } from './guards/level.guard';
import { PublicRootComponent } from './rootComponents/public-root/public-root.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { UserRootComponent } from './rootComponents/user-root/user-root.component';
import { AudioPlayerGuard } from './guards/base-guard.guard';
import { UserGuardGuard } from './guards/user-guard.guard';

const routes: Routes = [
  // Root redirect to login
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login',
  },

  // Public entries,
  {
    path: '',
    canActivate: [AudioPlayerGuard, AuthGuard],
    data: { authGuardReverse: true },
    children: [
      {
        path: '',
        children: [
          { path: 'login', component: LoginComponent },
          { path: 'register', component: RegisterComponent }
        ]
      }]
  },

  // Start entries
  {
    path: '',
    canActivate: [AudioPlayerGuard, AuthGuard, UserGuardGuard],
    children: [
      { path: 'createAvatar', component: CreateAvatarComponent }
    ]
  },

  // User entries
  {
    path: '',
    canActivate: [AudioPlayerGuard, AuthGuard, UserGuardGuard, CheckAvatarGuard],
    resolve: {progress: ProgressResolver},
    children: [
      {
        path: '',
        children: [
          { path: 'dashboard', component: DashboardComponent },
          {
            path: 'createAvatar', component: CreateAvatarComponent,
          },
          {
            // path: /level/1
            path: 'level/:id',
            // Wait for navigation until level is fetched
            component: LevelDashboardComponent,
            // TODO: create LevelGuard to check whether level may be opened
            canActivate: [LevelGuard],
            children: [
              {
                path: ':id',
                component: GameComponent,
                outlet: 'game',
                canActivate: [GameGuard],
                resolve: { game: GameResolver },
              }
            ]
          }
        ]
      },
      {
        path: '**',
        component: PageNotFoundComponent
      }]
  }
];
// {
//   path: '',
//   pathMatch: 'full',
//   component: PublicRootComponent,
//   // data: { authGuardReverse: true },
//   // canActivate: [AuthGuard],
//   resolve: { applicationText: ApplicationTextResolver },
//   children: [
//     { path: 'login', component: LoginComponent },
//     { path: 'register', component: RegisterComponent }
//   ]
// },
// {
//   path: '',
//   component: UserRootComponent,
//   canActivate: [AuthGuard],
//   resolve: { levels: LevelResolver },
//   children: [
//     {
//       path: 'dashboard',
//       component: DashboardComponent
//     },
//     {
//       path: 'createAvatar',
//       component: CreateAvatarComponent,
//     },
//     {
//       path: '',
//       canActivateChild: [CheckAvatarGuard],
//       children: [
//         {
//           path: 'dashboard',
//           component: DashboardComponent,
//         },
//         {
//           // path: /level/1
//           path: 'level/:id',
//           // Wait for navigation until level is fetched
//           component: LevelDashboardComponent,
//           // TODO: create LevelGuard to check whether level may be opened
//           canActivate: [LevelGuard],
//           children: [
//             {
//               // path: /level/3/(game:2)
//               path: ':id',
//               component: GameComponent,
//               outlet: 'game',
//               canActivate: [GameGuard],
//               resolve: { game: GameResolver, levels: LevelResolver },
//             }
//           ]
//         }
//       ]
//     }
//   ]
// },

// {
//   path: '',
//   resolve: {
//     applicationText: ApplicationTextResolver,
//     levels: LevelResolver
//   },
//   canActivateChild: [AudioGuard],
//   children: [
//     {
//       path: '',
//       // temp
//       resolve: {
//         levels: LevelResolver
//       },
//       canActivateChild: [AuthGuard],
//       data: { authGuardReverse: true },
//       children: [
//         {
//           path: 'login',
//           component: LoginComponent,
//           resolve: {
//             levels: LevelResolver
//           }
//         },
//         {
//           path: 'register',
//           component: RegisterComponent,
//           resolve: {
//             levels: LevelResolver
//           }
//         },
//       ]
//     },
//     {
//       path: '',
//       canActivateChild: [AuthGuard],
//       resolve: {
//         progress: ProgressResolver,
//         //temp
//         levels: LevelResolver
//       },
//       children: [
//         {
//           path: 'createAvatar',
//           component: CreateAvatarComponent,
//           resolve: {
//             levels: LevelResolver
//           }
//         },
//         {
//           path: '',
//           canActivateChild: [CheckAvatarGuard],
//           resolve: {
//             levels: LevelResolver
//           },
//           children: [
//             {
//               path: 'dashboard',
//               component: DashboardComponent,
//               resolve: {
//                 levels: LevelResolver
//               }
//             },
//             {
//               // path: /level/1
//               path: 'level/:id',
//               // Wait for navigation until level is fetched
//               component: LevelDashboardComponent,
//               resolve: {
//                 levels: LevelResolver
//               },
//               // TODO: create LevelGuard to check whether level may be opened
//               canActivate: [LevelGuard],
//               children: [
//                 {
//                   // path: /level/3/(game:2)
//                   path: ':id',
//                   component: GameComponent,
//                   outlet: 'game',
//                   canActivate: [GameGuard],
//                   resolve: { game: GameResolver, levels: LevelResolver },
//                 }
//               ]
//             }
//           ]
//         }
//       ]
//     },
//     { path: '**', redirectTo: 'login' }
//   ]
// }


@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
  providers: [
    ProgressResolver,
    LevelResolver,
    GameResolver,
    ApplicationTextResolver]
})
export class AppRoutingModule { }
